import {useEffect, useState, useRef} from "react";
import {Link, useLoaderData, useParams, useActionData, ScrollRestoration, Form, useSubmit} from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { getSearchInfo } from "../../server/getSearchInfo";
import { searchExcursions} from "../../server/search";
import ExcursionsGrid from "./ExcursionsGrid/ExcursionsGrid";
import SelectZoneDialog from "./SelectZoneDialog/SelectZoneDialog";
import useGetZone from "../../hooks/useGetZone";
import SEO from "components/SEO/SEO";

//CSS
import styles from "./search.module.less"

export async function loader({ params }) {
  const response = await getSearchInfo(params.language);

  if(process.env.REACT_APP_DEBUG === 'true') console.log("[SEARCH] -> Loader");
  if(process.env.REACT_APP_DEBUG === 'true') console.log("params", params);
  if(process.env.REACT_APP_DEBUG === 'true') console.log("response", response);

  if (!response.error){
    return response.data;
  }else{
    throw new Error("Loader finde excursión: ", { cause: response.error })
  }
}

export async function action({ params, request }) {

  if(process.env.REACT_APP_DEBUG === 'true') console.log("[SEARCH] -> Action");
  if(process.env.REACT_APP_DEBUG === 'true') console.log("params", params);
  if(process.env.REACT_APP_DEBUG === 'true') console.log("request", request);

  let formData = await request.formData();
  const findtext = formData.get("findtext");
  const zone = formData.get("zone");

  return {findtext:findtext, zone:zone};
}

export default function Search () {
  const loadData = useLoaderData();
  const actionData = useActionData();
  const [t,i18n] = useTranslation('pages');
  const zone  = useGetZone();
  const {slug} = useParams();
  const {language} = useParams();
  const [loading, setLoading] = useState(true);
  const [excursions, setExcursions] = useState(null);
  const [recommmendedExcursions, setRecommmendedExcursions] = useState(null);
  const [group, setGroup] = useState();
  const [searchText, setSearchText] = useState();
  const searchForm = useRef();
  const submitForm = useSubmit();
  const [visibleSelectZone, setVisibleSelectZone] = useState(false);

  if(process.env.REACT_APP_DEBUG === 'true' && actionData !== undefined) console.log("actionData", actionData);

  useEffect(()=>{
    let params={};
    if (language !== undefined) params.language=language;
    if (zone !== undefined) params.zone=zone;
    if (slug !== undefined) params.slug=slug;

    if (actionData !== undefined){
      params.zone=actionData.zone;
      sessionStorage.vtzone = actionData.zone;
      params.findtext = actionData.findtext;
      setSearchText(actionData.findtext);
    }else{
      setSearchText(undefined);
    }

    const promise = searchExcursions(params);

    setLoading(true);
    promise.then(response =>{
      if (response.error === 0){
        if (response.data.excursions!=null){
          setExcursions(response.data.excursions);
          setRecommmendedExcursions(null);
        }else{
          setExcursions(null);
          setRecommmendedExcursions(response.data.recommendedexcursions);
        }
        setGroup(response.data.group);
        setLoading(false);
        if(process.env.REACT_APP_DEBUG == 'true') console.log("[SEARCH] -> Excursions");
        if(process.env.REACT_APP_DEBUG == 'true') console.log("response", response);
      }else throw new Error("Loader excursións: ")
    })

  },[slug, zone, actionData])

  let groupsHTML = "No hay grupos de excursiones";

  if(Array.isArray(loadData.excursionsgroups) && loadData.excursionsgroups.length > 0){
    groupsHTML = loadData.excursionsgroups.map((group,index)=>{
      return <Link key={index} to={'/' + i18n.language + "/search/" + zone + '/' + group.webslug}><li>{group.name}</li></Link>
    });
  }

  return(
    <div className={styles.search}>
      <SEO title={t('search.SEOTitulo')} description={t('search.SEODescripcion')} name='Viajes Teide' type='excursion' />

      <div className={styles.sidebar}>

        <div className={styles.selectzone}>
          {t('search.Usted esta en')} <span className={styles.selectzonebuttom} onClick={()=>setVisibleSelectZone(true)}>{t('search.zona')} {zone==='north' ? t('search.norte'):t('search.sur')}</span>
        </div>

        <div className={styles.searchform}>
          <Form ref={searchForm} method="post" action={'/' + i18n.language + '/search/' + zone}>
            <div className={styles.inputwithicon}>
              <input type="text" name="findtext"  />
              <input type="hidden" name="zone" value={zone} />
              <span className={styles.findIcon} onClick={()=>{submitForm(searchForm.current)}} ><i className={styles.iconFinder}></i></span>
            </div>
          </Form>
        </div>

        <div className={styles.excursionsGroups}>{groupsHTML}</div>
      </div>

      <div className={styles.content}>

        {loading &&
          <div className={styles.loading}>
            <div className={styles.loadingBackground}>&nbsp;</div>
            <div className={styles.loadingContent}>
              <div className={styles.logo}></div>
            </div>
          </div>
        }

        {!loading &&
          <>
            <div className={styles.title}>
              {group && (<><span>{t('search.Categoria')}:</span> {group.name}</>)}
              {searchText && (<><span>{t('search.Resultados para')}:</span> {searchText}</>)}
            </div>

            {excursions &&
              <>
                <div className={styles.numberResults}>{t('search.Número de resultados')}: <span>{excursions ? excursions.length : 0}</span> {t('search.excursiones')}.</div>
                <ExcursionsGrid excursions={excursions} language={i18n.language} zone={zone} t={t} />
              </>
             }

            {recommmendedExcursions &&
              <>
              <div className={styles.title}>
              <span>{t('search.Excursiones recomendadas')}</span>
              </div>
              <ExcursionsGrid excursions={recommmendedExcursions} language={i18n.language} zone={zone} t={t} />
              </>
            }
          </>
        }

      </div>
      <SelectZoneDialog visible={visibleSelectZone} onAccept={()=>setVisibleSelectZone(false)} t={t} language={i18n.language}/>
      <ScrollRestoration />
    </div>
  )
}

